export const clubMembers = {
    namespaced: true,

    state: {
        filter: {
            squads: [],
            statuses: [],
            roles: [],
            query: ''
        }
    },

    mutations: {
        setClubMembersSquads(state, data) {
            state.filter.squads = [];
            data.forEach(squad => {
                Vue.set(squad, 'selected', false);
                state.filter.squads.push(squad);
            });
        },

        setClubMembersRoles(state, data) {
            state.filter.roles = [];
            data.forEach(role => {
                Vue.set(role, 'selected', true);
                state.filter.roles.push(role);
            });
        },

        setClubMembersStatuses(state, data) {
            state.filter.statuses = [];
            data.forEach(status => {
                Vue.set(status, 'selected', true);
                state.filter.statuses.push(status);
            });
        }
    },

    getters: {
        getClubMembersFilter(state) {
            return state.filter;
        }
    },

    actions: {
        userChangeStatus(context, payload) {
            return context.dispatch(
                'post',
                {
                    url: api + 'user-change-status/' + payload.id,
                    data: payload
                },
                { root: true }
            );
        },

        getUserStatuses(context) {
            return context.dispatch(
                'get',
                {
                    url: api + 'club-statuses'
                },
                { root: true }
            );
        }
    }
};
